import Reveal from '@/components/base/Reveal';
import { formula } from '@/mocks/strategy';

export default function FormulaIP() {
  return (
    <section id="formula" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 border border-accent-200">
              <i className="ri-star-line text-accent-700"></i>
              <span className="text-xs md:text-sm text-accent-900 whitespace-nowrap">
                超级视觉 IP · 品牌资产
              </span>
            </div>
            <h2 className="mt-5 font-heading font-bold text-3xl md:text-5xl text-foreground-950">
              4 + 1 + 4 = <span className="text-primary-600">9</span>
            </h2>
          </div>
        </Reveal>

        {/* 4大政策底座 */}
        <Reveal delay={80}>
          <div className="mt-12">
            <div className="text-center text-sm font-medium text-foreground-600 mb-5">
              4 大政策底座
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {formula.base.map((item) => (
                <div
                  key={item.title}
                  className="p-5 rounded-lg bg-background-100 border border-background-200 text-center"
                >
                  <div className="w-11 h-11 mx-auto rounded-full bg-primary-100 flex items-center justify-center">
                    <i className={`${item.icon} text-primary-600 text-xl`}></i>
                  </div>
                  <div className="mt-3 text-sm font-medium text-foreground-950 whitespace-nowrap">
                    {item.title}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        {/* 向下箭头 */}
        <div className="flex justify-center my-6">
          <i className="ri-arrow-down-line text-foreground-400 text-2xl"></i>
        </div>

        {/* 1个核心政策接口 */}
        <Reveal delay={120}>
          <div className="max-w-xl mx-auto p-6 rounded-lg border border-secondary-400 bg-secondary-50 text-center">
            <div className="text-xs text-secondary-700 font-medium mb-2">1 个国家政策接口</div>
            <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
              {formula.core.title}
            </h3>
            <div className="mt-2 text-sm text-secondary-700">{formula.core.doc}</div>
          </div>
        </Reveal>

        {/* 向下箭头 */}
        <div className="flex justify-center my-6">
          <i className="ri-arrow-down-line text-foreground-400 text-2xl"></i>
        </div>

        {/* 4大应用体系 */}
        <Reveal delay={160}>
          <div className="text-center text-sm font-medium text-foreground-600 mb-5">
            4 大应用体系
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {formula.systems.map((item) => (
              <div
                key={item.title}
                className="p-5 rounded-lg bg-background-100 border border-background-200 text-center"
              >
                <div className="w-11 h-11 mx-auto rounded-full bg-accent-100 flex items-center justify-center">
                  <i className={`${item.icon} text-accent-700 text-xl`}></i>
                </div>
                <div className="mt-3 text-sm font-medium text-foreground-950 leading-snug">
                  {item.title}
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        {/* 向下箭头 */}
        <div className="flex justify-center my-6">
          <i className="ri-arrow-down-line text-foreground-400 text-2xl"></i>
        </div>

        {/* 结果 */}
        <Reveal delay={200}>
          <div className="flex justify-center">
            <div className="px-8 py-5 rounded-lg bg-primary-500 text-background-50 text-center">
              <div className="font-heading font-bold text-2xl md:text-3xl">
                {formula.result.title}
              </div>
              <div className="mt-1 text-sm text-background-100">{formula.result.sub}</div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={240}>
          <p className="mt-8 text-center text-sm text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            4 大政策底座 + 1 个国家政策接口 + 4 大应用体系，汇聚为九畴云铺——乡村数字经济操作系统。
          </p>
        </Reveal>
      </div>
    </section>
  );
}